import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import * as toggle from '../../../../core/action/toggle';
import * as ActionServerVoip from '../../../../core/action/Voip/Server/ActionServer';
import ButtonEditServerVoipComponent from '../../../../components/Content/Voip/ServerVoip/ButtonEditServerVoipComponent';
import { connect } from 'react-redux';

interface IProps {
  id: any;
  actionToggle: any;
  actionServerVoip: any;
}

class ButtonEditServerVoipContainer extends Component<IProps> {
  constructor(props: any) {
    super(props);
    this.handleChangeAndPopUpModal = this.handleChangeAndPopUpModal.bind(this);
  }
  handleChangeAndPopUpModal() {
    this.props.actionServerVoip.setServerVoipId(this.props.id);
    this.props.actionServerVoip.submitDetailServerVoip();
  }
  render() {
    return (
      <React.Fragment>
        <ButtonEditServerVoipComponent
          handleChangeAndPopUpModal={this.handleChangeAndPopUpModal}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  TypeToggle: state.Toggle.jenisToggle,
});

const mapDispatchToProps = (dispatch: any) => ({
  actionToggle: bindActionCreators(toggle, dispatch),
  actionServerVoip: bindActionCreators(ActionServerVoip, dispatch),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ButtonEditServerVoipContainer);
